import { render, staticRenderFns } from "./FichaAfiliacion.html?vue&type=template&id=75c70a05&external"
import script from "./FichaAfiliacion.vue?vue&type=script&lang=js"
export * from "./FichaAfiliacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports